import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBarLevel3 = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.33333 15H2.66667C2.29848 15 2 15.2149 2 15.48V20.52C2 20.7851 2.29848 21 2.66667 21H5.33333C5.70152 21 6 20.7851 6 20.52V15.48C6 15.2149 5.70152 15 5.33333 15Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.3333 11H7.66667C7.29848 11 7 11.2388 7 11.5333V20.4667C7 20.7612 7.29848 21 7.66667 21H10.3333C10.7015 21 11 20.7612 11 20.4667V11.5333C11 11.2388 10.7015 11 10.3333 11Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.3333 7H12.6667C12.2985 7 12 7.25072 12 7.56V20.44C12 20.7493 12.2985 21 12.6667 21H15.3333C15.7015 21 16 20.7493 16 20.44V7.56C16 7.25072 15.7015 7 15.3333 7Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.667 3.5H20.333C20.4011 3.5 20.4508 3.52392 20.4775 3.54688C20.49 3.55765 20.4958 3.56686 20.498 3.57129C20.4991 3.57337 20.4999 3.57492 20.5 3.5752V20.4248C20.4999 20.4251 20.4991 20.4266 20.498 20.4287C20.4958 20.4331 20.49 20.4424 20.4775 20.4531C20.4508 20.4761 20.4011 20.5 20.333 20.5H17.667C17.5989 20.5 17.5492 20.4761 17.5225 20.4531C17.51 20.4424 17.5042 20.4331 17.502 20.4287C17.5009 20.4266 17.5001 20.4251 17.5 20.4248V3.5752C17.5001 3.57492 17.5009 3.57337 17.502 3.57129C17.5042 3.56686 17.51 3.55765 17.5225 3.54688C17.5425 3.52965 17.5753 3.51169 17.6191 3.50391L17.667 3.5Z",
			stroke: "currentColor"
		})
	]
});
export default SvgBarLevel3;
